<template>
  <div>
    <section class="bg-half-170 d-table w-100 overflow-hidden" id="home">
      <div class="container">
        <div class="row align-items-center pt-5">
          <div class="col-lg-7 col-md-6">
            <div class="title-heading">
              <h1 class="heading mb-3" v-html="$t('home.welcomeMsg')"></h1>
              <p class="text-muted mb-3" v-html="$t('home.leading')"></p>
              <h4 class="text-info mb-4" v-html="$t('home.shortDesc')"></h4>

              <div v-if="publicPackages">
                <h5>Trenutno aktivne raziskave:</h5>
                <b-list-group>
                  <div v-for="pkg in publicPackages" v-bind:key="pkg.id">
                    <b-list-group-item
                      :to="{
                        name: 'Package',
                        params: { packageSlug: pkg.slug },
                      }"
                      class="d-flex justify-content-between align-items-center rounded mb-2 bg-dark text-white"
                    >
                      {{ pkg.title }}
                      <font-awesome-icon icon="arrow-right" class="text-info" />
                    </b-list-group-item>
                  </div>
                </b-list-group>
              </div>
              <div v-else>
                <h5 class="mb-2">
                  <font-awesome-icon icon="info-circle" class="mr-2" />
                  Trenutno žal ni aktivnih raziskav.
                </h5>
              </div>
            </div>
            <div class="my-3 p-3 border border-primary rounded">
              <h4 class="text-muted mb-3">
                Želite biti obveščeni o novih aktivnih raziskavah?
              </h4>
              <form
                action="https://brevisvelox.us5.list-manage.com/subscribe/post?u=baf2e92589d5e24d9115308f2&amp;id=a5054992f7"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate"
                target="_blank"
                novalidate
              >
                <div class="input-group">
                  <input
                    type="email"
                    value=""
                    name="EMAIL"
                    class="form-control"
                    id="mce-EMAIL"
                    placeholder="Vaš email naslov "
                    required
                  />
                  <div class="input-group-append">
                    <input
                      type="submit"
                      value="Prijavite se na obvestila"
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      class="btn btn-sm btn-success rounded-right"
                    />
                  </div>
                  <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div
                    style="position: absolute; left: -5000px;"
                    aria-hidden="true"
                  >
                    <input
                      type="text"
                      name="b_baf2e92589d5e24d9115308f2_a5054992f7"
                      tabindex="-1"
                      value=""
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!--end col-->

          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Section Start -->

    <a
      v-if="showToTop"
      href="#"
      class="btn btn-icon btn-soft-primary back-to-top d-block"
      v-scroll-to="'#topnav'"
      ><font-awesome-icon icon="arrow-up"
    /></a>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Default-Layout",
  components: {},
  data() {
    return {
      showToTop: false,
      navOpen: false,
    };
  },
  created() {
    this.$store.dispatch("api/fetchPublicPackages");
  },
  mounted: function() {
    this.toTopListener();
    window.addEventListener("scroll", this.toTopListener);
  },
  computed: {
    ...mapGetters({
      publicPackages: "api/getPublicPackages",
    }),
  },
  methods: {
    toTopListener: function() {
      var headerWrapper = document.getElementById("topnav");

      if (window.scrollY > 30) {
        this.showToTop = true;
        headerWrapper.classList.add("nav-sticky");
      } else {
        this.showToTop = false;
        headerWrapper.classList.remove("nav-sticky");
      }
    },
  },
  beforeDestroy: function() {
    window.removeEventListener("scroll", this.toTopListener);
  },
};
</script>
